<app-ag-grid id="groups-table"
             class="display-block lh-34 full-height"
             [suppressContextMenu]="true"
             [gridOptions]="{
                suppressDragLeaveHidesColumns: true,
                rowHeight: 35,
                groupHeaderHeight: 64,
                headerHeight: 64,
                colResizeDefault: 'shift'
             }"
             [paginationPageSize]="25"
             [defaultColDef]="defaultColDef"
             [columnDefs]="metricsGroupsColumnDefs"
             [loader]="loading$ | async"
             [rowData]="categories$ | async">
  <ng-template #name let-row>
    <app-source [item]="row.payload"></app-source>
  </ng-template>
  <ng-template #count let-row>
    <app-loader [enable]="row.loading$ | async"
                diameter="15">
      <div class="display-flex flex-align-center gap-0-5em">
        {{ row.length$ | async }}
        <mat-icon class="material-icons-outlined icon-info"
                  customToolTip
                  [contentTemplate]="tooltip"
                  *ngIf="row.length$ | async">info</mat-icon>
        <ng-template #tooltip>
          <app-source [item]="item.payload"
                      [enableCategory]="true"
                      *ngFor="let item of row.items$ | async"></app-source>
        </ng-template>
      </div>
    </app-loader>
  </ng-template>
  <ng-template #groupActionsColumn let-row>
    <div class="actions full-height display-flex flex-align-center justify-content-end">
      <app-icon [style]="'material-icons-outlined cursor color-grey-light color-blue-hover'"
                icon="edit"
                class="display-inline-flex"
                [disabled]="appS.isNotDatasetAdmin || !row.payload.attributes.is_deletable"
                [matTooltip]="'tooltip.edit' | translate"
                (onClick)="onUpdate(row)"></app-icon>
      <app-icon [style]="'material-icons-outlined cursor color-grey-light color-red-hover'"
                icon="delete"
                class="display-inline-flex"
                [disabled]="appS.isNotDatasetAdmin || !row.payload.attributes.is_deletable || row.payload.attributes.is_deletable && row.payload.attributes.metrics_number"
                [matTooltip]="'tooltip.delete' | translate"
                (onClick)="onDelete(row)"></app-icon>
    </div>
  </ng-template>
</app-ag-grid>
